module.exports = __webpack_public_path__ + "8be0dae1.webp";